import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import { withRouter, useHistory } from "react-router-dom";
import Map from "core/ui/mapping/map";
import Chart from "core/ui/charts/index";
import TweenedNumber from "core/ui/tweened-number";
import ChartFinder from "partials/chart-finder";
import MapSearch from "partials/map-search";
import MapLayers from "partials/map-layers";
import MapAdHoc from "partials/map-adhoc";
import MapPointsConfigurator from "partials/map-points-configurator";
import DropZone from "core/ui/drop-zone";
import SessionContext from "SessionContext";
import ComplexFilterBuilder from "./complex-filter-builder";
import download from 'core/utils/save-string-as-file';
import { usePrevious } from "hooks/usePrevious";
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Form,
  PopoverBody, 
  PopoverHeader, 
  Popover
} from "reactstrap";
import ProgressLoader from "partials/progress-loader";
import debounce from "lodash.debounce";
import isEqual from "lodash.isequal";
import lodash from "lodash";
import { known_chart_ids } from "hooks/useChartsStore";
import HasLicenseFee from "core/utils/has-license-fee";
import { useRef } from "react";
import LZString from 'lz-string';
import TextInput from "core/ui/forms/text-input";
import HelpTip from "core/ui/help/HelpTip";
import { dedupe_max_limit } from "../core/utils/constants";
import useAudienceStore from "../store/useAudienceStore";
import AudienceUnsavedModal from "partials/audienceUnsavedModal";

export const formatPopulationDomain = (_domain) => {
  return _domain
    .split('_')
    .map(val => val.charAt(0).toUpperCase() + val.slice(1))
    .join(' ');
}

const Explorer = (props) => {
  const context = useContext(SessionContext);
  const explorerModule = context.crossfilterStore.explorerModule;
  const history = useHistory();

  const { isAudienceSaved, setIsAudienceSaved } = useAudienceStore();
  const expandedState = JSON.parse("[]");
  const minQuantity = useRef(
    `${window.min_order_quantity}` !== "undefined"
      ? `${window.min_order_quantity}`
      : 100
  );
  const [isExpanded, setIsExpanded] = useState(expandedState);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAudience, setSelectedAudience] = useState({});
  const [savedAudienceName, setSavedAudienceName] = useState("");
  const [audienceNameRef, setAudienceNameRef] = useState(null);
  const [map, setMap] = useState(null);
  const [mapCenter, setMapCenter] = useState(
    JSON.parse(
      localStorage.getItem("am:audience:map:center") ||
      // US large
      '{"lat": 41.5686, "lng": -96.2698}'
    )
  );
  const [mapZoom, setMapZoom] = useState(localStorage.getItem("am:audience:map:zoom") || 4);
  const mapState = usePrevious({ mapCenter, mapZoom });
  const [isLoadingMapCrossfilterData, setIsLoadingMapCrossfilterData] = useState(true);
  const [editing, setEditing] = useState(false);
  const [filters, setFilters] = useState([]);
  const [insights, setInsights] = useState();
  const [draggingFilters, setDraggingFilters] = useState(false);
  const [draggingInsights, setDraggingInsights] = useState(false);
  const [dedupeDropDownIsOpen, setDedupeDropDownIsOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [empty, setEmpty] = useState(true);
  const [complex, setComplex] = useState(false);
  const [complexQuery, setComplexQuery] = useState(null);
  const [complexModified, setComplexModified] = useState(false);
  const [complexFields, setComplexFields] = useState(null);
  const [revertToSimpleModalIsOpen, setRevertToSimpleModalIsOpen] = useState(false);
  const [convertToComplexModalIsOpen, setConvertToComplexModalIsOpen] = useState(false);
  const [convertToComplexModalMatchLevelIsOpen, setConvertToComplexModalMatchLevelIsOpen] = useState(false);
  const [orderBelowMinModalIsOpen, setOrderBelowMinModalIsOpen] = useState(false);
  const [duplicatedNameModalIsOpen, setDuplicatedNameModalIsOpen] = useState(false);
  const [clearAllFiltersModalIsOpen, setClearAllFiltersModalIsOpen] = useState(false);
  const [clearAllInsightsModalIsOpen, setClearAllInsightsModalIsOpen] = useState(false);
  const [duplicatedName, setDuplicatedName] = useState(false);
  const [mapControls, setMapControls] = useState(null);
  const [nameIsFocused, setNameIsFocused] = useState(false);
  const [pageActionDropDownIsOpen, setPageActionDropDownIsOpen] = useState(false);
  const [hasLicenseFee, setHasLicenseFee] = useState(false);
  const [showNeedLicense, setShowNeedLicense] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [isNewAudience, setIsNewAudience] = useState(false);
  const lastAudienceID = useRef(JSON.parse(localStorage.getItem("am:audience:lastid")) || "");
  const lastAudienceState = useRef(JSON.parse(LZString.decompress(localStorage.getItem("am:audience:audience_state")) || "{}"));
  const savedAudience = useRef({});
  const [downloadCountsInfoOpen, setDownloadCountsInfoOpen] = useState(false);
  const [insightCountsOnly, setInsightCountsOnly] = useState(false);
  const [reportReady, setReportReady] = useState(false);
  // eslint-disable-next-line
  const [dataFiltersHaveChanged, setDataFiltersHaveChanged] = useState(false);
  const [missingData, setMissingData] = useState();
  const [missingDataModalIsOpen, setMissingDataModalIsOpen] = useState(false);
  const [companyId, setCompanyId] = useState();
  const [dedupeErrorMessagesIsOpen, setDedupeErrorMessagesIsOpen] = useState(false);
  const [dedupeErrorMessage, setDedupeErrorMessage] = useState(`Your audience size now exceeds ${dedupe_max_limit.toLocaleString()} records so your uniqueness level has been reset to Individual.`);
  const [showCompareLink, setShowCompareLink] = useState(false);
  const [currentAudienceId, setCurrentAudienceId] = useState("");
  const [noLifeEventSelection, setNoLifeEventSelection] = useState(false);
  const [noMoversSelection, setNoMoversSelection] = useState(false);
  const [showUnsavedExplorerModal, setShowUnsavedExplorerModal] = useState(false);
  const [blockedLocation, setBlockedLocation] = useState(null);
  const [taxonomyLoaded, setTaxonomyLoaded] = useState(false);


  /* keep local track of unsaved changes */
  const savedRef = useRef(saved);
  const emptyRef = useRef(empty);
  const editingRef = useRef(editing);

  useEffect(() => { savedRef.current = saved; }, [saved]);
  useEffect(() => { emptyRef.current = empty; }, [empty]);
  useEffect(() => { editingRef.current = editing; }, [editing]);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if(location.pathname === '/order' || 
         location.pathname === '/model' ||
         location.pathname === '/insights-pdf-report'
        ) { return }
      if(shouldAskToSave()) {
        setBlockedLocation({ location, action });
        setShowUnsavedExplorerModal(true);
        return false; // blocks navigation
      }
    });

    return () => unblock();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleProceed = () => {
    const unblock = history.block(() => {}); // temporarily remove block
    unblock();

    if(blockedLocation.action === "POP") {
      history.goBack();
    } else {
      history.push(blockedLocation.location.pathname);
    } 
    
    setBlockedLocation(null);
    setShowUnsavedExplorerModal(false);
    onClickNewCallback();
  };

  const handleReturn = () => {
    setBlockedLocation(null);
    setShowUnsavedExplorerModal(false);
  };

  const shouldAskToSave = () => {
    let has_changes = lastAudienceID.current && editingRef.current;
    let is_new_unsaved = !lastAudienceID.current && !emptyRef.current && !savedRef.current;

    if(has_changes || is_new_unsaved) {
      return true;
    } else {
      return false;
    }
  };

  /* end of keep local track of unsaved changes */


  // MAIN COMPONENT MOUNT FUNCTION
  useEffect(() => {

    const should_load_stored_audience = !props.args.audience && !localStorage.getItem("am:audience:lastid");

    // this checks if explorer is loading with stored filters, check to see if the user is creating a new audience, if not: remove stored filters
    if (!should_load_stored_audience && !lastAudienceState.current?.id && lastAudienceState.current?.filters && !lastAudienceState.current?.location_type_ids) {
      lastAudienceState.current = {};
      lastAudienceID.current = "";
      localStorage.removeItem("am:audience:audience_state");
      localStorage.removeItem("am:audience:lastid");
      localStorage.removeItem("am:audience:filters");
      context.crossfilterStore.setFilters({});
    }

    // Get last stored audience state
    const unsavedAudience = lastAudienceState.current;
    // Any prop ids for audience ID
    const pAudience = props.args.audience || localStorage.getItem("am:audience:lastid");
    // Currently modified audience ID
    const sAudience = selectedAudience.id && selectedAudience.id.toString();

    // Determine if page load has a query param or not and if the same audience ID or not.
    // When loading an audience from the list, there is an ID in the query params.
    // When navigating to another page and back, even if the same audience, there is no query param, so check the last stored ID.
    let sameAudienceID = false;
    if(pAudience){
      sameAudienceID = pAudience === lastAudienceID.current.toString();
    }else{
      sameAudienceID = lastAudienceState?.current.id?.toString() === lastAudienceID.current?.toString();
    }

    // current audience ID to use
    let cAudience = pAudience;
    
    // Check for audience IDs, from props, selected or last state
    if (pAudience) {
      cAudience = pAudience;
    } else if (sAudience) {
      // Remove any residual location icons (they get rebuilt)
      context.crossfilterStore.removeAllLocationTypePoints();
      cAudience = sAudience;
    } else if (lastAudienceID.current && !pAudience) {
      // Remove any residual location icons (they get rebuilt)
      context.crossfilterStore.removeAllLocationTypePoints();
      // localStorage save ID when not coming in with props (which happens with page switching)
      cAudience = lastAudienceID.current;
    }
    
    // If there is an incoming or stored ID
    if (cAudience) {
      lastAudienceID.current = cAudience;
      setIsLoading(true);
      context
      .query("audience/get", {
        id: cAudience,
      })
      .then((audience) => {
        // if the audience and the population don't match: start a new audience
        if(audience.population_domain !== context.crossfilterStore.explorerModule) {
          onClickNewCallback();
          return;
        }

        // Update the last saved audience to compare with
        savedAudience.current = audience;
        
        if (unsavedAudience.id !== audience.id){
          setMapCenter(audience.map_state.map_center);
          setMapZoom(audience.map_state.map_zoom);
        }
        
        // Are they the same? 
        const isAudienceUpdated = compareAudiences();
        
        // If not loading via props (URL Query) check that they are not same audience
        if (sameAudienceID && isAudienceUpdated) {
          setSelectedAudience(unsavedAudience);
          context.crossfilterStore.setAudience(unsavedAudience);
          // Remove any residual location icons (they get rebuilt)
          context.crossfilterStore.removeAllLocationTypePoints();
          if (unsavedAudience.is_complex) {
            setComplex(unsavedAudience.is_complex || false);
            if (unsavedAudience.complex_filters.tree) {
              setComplexQuery(unsavedAudience.complex_filters);
            }
          }
          // Otherwise load the existing audience by stored ID from localStorage. 
        } else {
          // Remove any residual location icons (they get rebuilt)
          context.crossfilterStore.removeAllLocationTypePoints();

          context.crossfilterStore.restoreFromAudience(cAudience);
          if (audience.is_complex) {
            setComplex(audience.is_complex || false);
            if (audience.complex_filters.tree) {
              setComplexQuery(audience.complex_filters);
            }
          }
          setSelectedAudience(audience);
        }
        setLoaded(context.crossfilterStore.audienceLoaded);
        setMapControlsUI();
        setIsLoading(false);
        })
      .catch((err) => {
        console.log("Failed to load the audience ",  err)
        setIsLoading(false);
        onClickNewCallback();
      })
    } else {
      if (!isEmptyAudience()) {
        setSelectedAudience(unsavedAudience);
        context.crossfilterStore.restoreFromAudience(unsavedAudience);
        if (unsavedAudience.is_complex) {
          setComplex(unsavedAudience.is_complex || false);
          if (unsavedAudience.complex_filters.tree) {
            setComplexQuery(unsavedAudience.complex_filters);
          }
        }
      }
      setLoaded(true);
      setIsLoading(false);
      setEmpty(true);
    }
    setMapControlsUI();
    setCompanyId(context.appState.activeCompany.id);
    
    // Unmount explorer
    return () => {
      const save_before_unmount = props.args.audience || localStorage.getItem("am:audience:lastid") || null;
      if(save_before_unmount) {
        localStorage.setItem("am:audience:lastid", save_before_unmount);
      } else {
        localStorage.removeItem("am:audience:lastid");
      }
      
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const update_complex_fields = () => {
    if (!complex) return;
    context.crossfilterStore.getComplexFields()
    .then((_complexFields) => {
      setComplexFields(_complexFields);
    });
  }
  
  // To run after everything is actually loaded.
  useEffect(() => {
    if (!isLoading && loaded && context.crossfilterStore.loaded && context.crossfilterStore.audienceLoaded && map) {
      setMapControlsUI();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, loaded, map]);

  useEffect(() => {
    setIsLoadingMapCrossfilterData(context.crossfilterStore.loading_map_data);
    if (!context.crossfilterStore.loading_map_data && context.crossfilterStore.loaded && !isLoading) {
      setSelectedAudience({ ...selectedAudience });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.crossfilterStore.loading_map_data, context.crossfilterStore.loaded, isLoading]);
  
  // Respond to changes in audience
  useEffect(() => { 
    if (!Object.keys(selectedAudience).length || !context.crossfilterStore.loaded || !context.crossfilterStore.audienceLoaded) return;
    // Save latest state of audience in localStorage
    if (Object.values(selectedAudience).length) {
      const audienceState = {
        ...selectedAudience,
        ...(savedAudienceName && {name: savedAudienceName}),
        ...(complex && complexQuery && { complex_filters: complexQuery, is_complex: true, filters: {}}),
        ...{dedupe_level: context.crossfilterStore.dedupe},
      }
      context.crossfilterStore.setAudience(audienceState);
      localStorage.setItem("am:audience:audience_state", LZString.compress(JSON.stringify(audienceState)));
      !isNewAudience && audienceState.id && localStorage.setItem("am:audience:lastid", JSON.stringify(audienceState.id));
      lastAudienceState.current = selectedAudience;

      if (selectedAudience.filter_errors && (selectedAudience.filter_errors.missing_features || selectedAudience.filter_errors.missing_values)) {
        if (selectedAudience.filter_errors.missing_features.length || selectedAudience.filter_errors.missing_values.length) {
          setDataFiltersHaveChanged(true);
          setMissingData(selectedAudience.filter_errors);
          setEditing(true);
        }
      }
    }

    // check for empty
    const is_empty = isEmptyAudience();
    setEmpty(is_empty);
    // compare current audience with last saved audience state
    compareAudiences();
    setMapControlsUI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAudience]);
  
  // Filter changes
  useEffect(() => { 
    if (!isLoading) {
      const newFilters = filters;
      if (Object.keys(newFilters).length) {
        const updatedAudience = { ...selectedAudience, filters: newFilters };
        // update current page audience with changes
        setSelectedAudience(updatedAudience);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  // Complex Filter changes
  useEffect(() => { 
    if (!isLoading && context.crossfilterStore.audienceLoaded) {
      
      let updatedAudience;
      if (complex && complexQuery && complexQuery.tree) {
        const newComplexFilters = complexQuery.tree || {};
        updatedAudience = { ...selectedAudience, complex_filters: newComplexFilters, is_complex: true };
      } else {
        updatedAudience = { ...selectedAudience, complex_filters: {}, is_complex: false };
      }

      if (!isEqual(updatedAudience, selectedAudience)) {
        setSelectedAudience(updatedAudience);
      }

      if (complexQuery && Object.keys(complexQuery).length) {
        let hasEmpty = hasEmptyComplexFields();
        if (hasEmpty && !empty) {
          setEmpty(true)
        };
        
        const complexFiltersChanged = !isEqual(complexQuery.tree, selectedAudience.complex_filters);
        if (complexFiltersChanged) {
          applyComplexFilter();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complexQuery]);
  
  useEffect(() => {
    if (!isEqual(complexQuery, context.crossfilterStore.complexFilters)) {
      setComplexQuery(context.crossfilterStore.complexFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.crossfilterStore.missingComplexFilters, context.crossfilterStore.complexFilters]);

  // Insight changes
  useEffect(() => { 
    if (!isLoading) {
      const newInsights = insights;
      let updatedAudience;
      if (Object.values(newInsights).length) {
        updatedAudience = { ...selectedAudience, insights: newInsights };
      } else {
        updatedAudience = { ...selectedAudience, insights: [] };
      }
      setSelectedAudience(updatedAudience);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insights]);

  // Name changes
  useEffect(() => { 
    if (isLoading) return;
    setSelectedAudience({ ...selectedAudience, name: savedAudienceName });
    compareAudiences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedAudienceName]);

  useEffect(() => { 
    if (dataFiltersHaveChanged) {
      setEditing(true);
    }
  }, [dataFiltersHaveChanged]);
  
  // Check for last audience updates. This effectively turns a useRef into a useState. Possibly change to a useState. 
  useEffect(() => { 
    // If not loading still, new or no ID
    if (!isLoading && !isNewAudience) {
      if (lastAudienceID.current !== undefined) {
        localStorage.setItem("am:audience:lastid", JSON.stringify(lastAudienceID.current));
      } else if (savedAudience.current.id) {
        localStorage.setItem("am:audience:lastid", JSON.stringify(savedAudience.current.id));
      } else {
        localStorage.setItem("am:audience:lastid", JSON.stringify(""));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastAudienceID.current, savedAudience.current]);

  // Change audience saved in useAudienceState for outside access to saved state.
  // This is for the global dialog to warn when an unsaved audience will be replaced. 
  useEffect(() => { 
    if (empty) {
      context.audienceSaved.saved(true);
    } else {
      context.audienceSaved.saved(!editing);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing, empty]);
  
  // Respond to filter updates from useCrossfilterStore 
  useEffect(() => {
    if(!context.crossfilterStore.audienceLoaded) return;
    setFilters(context.crossfilterStore.filters);
  }, [context.crossfilterStore.filters, context.crossfilterStore.audienceLoaded]);
  
  // Respond to insight updates from useCrossfilterStore 
  useEffect(() => {
    setInsights(context.crossfilterStore.widgets);
  }, [context.crossfilterStore.widgets]);
  
  
  // Refresh map counts
  useEffect(() => {
    if (!loaded && isLoadingMapCrossfilterData) return;
    if (!isEqual(mapState.mapCenter, mapCenter) || mapState.mapZoom.toString() !== mapZoom.toString()) {
      context.crossfilterStore.runCountRefresh(); 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapCenter, mapZoom])

  // keep track of what explorer we are using
  useEffect(() => {
    !empty && onClickNewCallback();
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [context.crossfilterStore.explorerModule])

  useEffect(() => {
    if( localStorage.getItem("am:new_explorer") === "yes" ) {
      localStorage.setItem("am:new_explorer", "no");
      onClickNewCallback();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [])

  useEffect(() => {
    if(loaded && !explorerModule) {
      props.history.push('/');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [loaded])

  useEffect(() => {
    if (context.chartsStore.loaded && context.chartsStore.taxonomy) {
      setTaxonomyLoaded(true);
    }
  }, [context.chartsStore.loaded, context.chartsStore.taxonomy]);

  /*
  /* METHOD FUNCTIONS 
  */
  
  // * THE MAIN AUDIENCE COMPARISON *
  const compareAudiences = () => {
    // if there is no unsaved audience being compared with (new audience or loaded audience
    // audience with a different ID, return false as we should not compare them. 
    if (!Object.keys(lastAudienceState.current).length) return false;

    // Remove fields for comparison - needed for recently saved audiences.
    let sA = {...savedAudience.current};
    let uA = {...lastAudienceState.current};
    delete sA.updated_date;
    delete uA.updated_date;
    delete sA.created_date;
    delete uA.created_date;
    delete sA.count;
    delete uA.count;
    delete sA.filter_errors
    delete uA.filter_errors;
    if (!sA.insights) { sA.insights = [] };
    let complex_filter_edits = false;


    const normalizeIsNegated = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(normalizeIsNegated);
      }
      if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
          if (key === 'is_negated' && (obj[key] === '' || obj[key] === false) ) {
            acc[key] = 0;
          } else {
            acc[key] = normalizeIsNegated(obj[key]);
          }
          return acc;
        }, {});
      }
      return obj;
    };

    // data comes different at times, normalize it before comparing
    sA = normalizeIsNegated(sA);
    uA = normalizeIsNegated(uA);

    // check complex filters first if it is complex
    if (selectedAudience.is_complex) {
      let cFsA = sA.complex_filters;
      let cFuA = uA.complex_filters;
      // compare the right structure as some are just the children node
      if (cFuA && !cFuA.tree && cFsA && cFsA.tree) {
        cFsA = cFsA.tree ;
      }
      if (cFsA && Object.keys(cFsA).length && cFuA && Object.keys(cFuA).length) {
        complex_filter_edits = !isEqual(deepSortObject(cFsA), deepSortObject(cFuA));
      }
      if (complex_filter_edits) {
        setEditing(true);
        return true;
      } else {
        // delete complex filters to compare the rest of the audience
        delete sA.complex_filters;
        delete uA.complex_filters;
      }
    }
    
    const edits = dataFiltersHaveChanged || !isEqual(deepSortObject(sA), deepSortObject(uA));

    setEditing(edits);
    return edits;
  }

  /** 
   * use a lodash built-in function to sort arrays and objects with sub-objects, 
   * sorts the props to allow comparison when values are the same but in a different order
  **/
  function deepSortObject(obj) {
    if (lodash.isArray(obj)) {
      return obj.map(deepSortObject).sort(compareObjects);
    } else if (lodash.isPlainObject(obj)) {
      return lodash(obj)
        .toPairs()
        .sortBy(0)
        .map(([key, value]) => [key, deepSortObject(value)])
        .fromPairs()
        .value();
    }
    return obj;
  }

  // compare objects after were sorted
  function compareObjects(a, b) {
    const aSorted = deepSortObject(a);
    const bSorted = deepSortObject(b);
    return JSON.stringify(aSorted).localeCompare(JSON.stringify(bSorted));
  }

  const getAudienceDownloadFullCSV = async () => {
    const filtered_charts = Object.keys(
      context.crossfilterStore.filters
    );
    const insights = context.crossfilterStore.widgets;

    const csvFilters = insightCountsOnly ? null : await context.crossfilterStore.getAudienceDownloadData(filtered_charts, "Filter");
    const csvInsights = await context.crossfilterStore.getAudienceDownloadData(insights, "Insight");

    let combined = [];
    if (csvFilters && csvInsights) { 
      combined = csvFilters.flat().concat(csvInsights.flat());
    } else if (csvFilters && !csvInsights) {
      combined = csvFilters.flat();
    } else if (!csvFilters && csvInsights) {
      combined = csvInsights.flat();
    }
    setInsightCountsOnly(false);
    return combined;
  }

  const onClickDownload = () => {
    triggerDownload((filename, headers, values)=> {
      const content = [headers.join(',')].concat(values.map(v => v.join(','))).join('\n');
      download(filename, content);
    })
  }

  const triggerDownload = async (download) => {
    let audienceName = selectedAudience.name;
    audienceName = (audienceName) ? audienceName.replace(/[^A-z0-9-_]+/g, "_") + ' - ' : 'Untitled';
    const filename = `${audienceName} - ${getCurrentDate()}.csv`;
    const values = await getAudienceDownloadFullCSV();
    let headers;
    const hasMatchLevels = values.some((v) => v.length > 6);
    headers = context.crossfilterStore.getCSVHeaders(hasMatchLevels);
    download(filename, headers, values);
  }

  const getCurrentDate = () => {
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${month}-${day}-${year}`;
    return currentDate;
  }

  const handleClearAllFilters = () => {
    context.crossfilterStore.removeAllLocationTypePoints();
    context.crossfilterStore.remove_all_adhoc_points();
    setFilters({});
    lastAudienceState.current.filters = {};
    context.crossfilterStore.setFilters({});
    toggleClearAllFiltersModal();
    complex && onRevertToSimpleFilter();
  };

  const handleClearAllInsights = () => {
    context.crossfilterStore.setWidgets([]);
    toggleClearAllInsightsModal();
  };


  const onChangeSearchTerm = (ev) => {
    setSearchTerm(ev.target.value.replace(/[$^*()+[\]\\?]/g, ""));
  };

  const refreshCount = () => {
    context.crossfilterStore.runCountRefresh();
  }

  const onClickExpand = (rail, ev) => {
    ev.currentTarget && ev.currentTarget.blur();
      let [curr, prev, prev2, prev3] = isExpanded;
      let new_stack;
      const stack_index = isExpanded.indexOf(rail);
      if (rail === curr) {
        new_stack = [prev, prev2, prev3];
      } else if (stack_index > -1) {
        // go back
        new_stack = isExpanded.slice(stack_index);
      } else {
        // go forward
        if (curr && curr.indexOf("add-") === 0) {
          // dont push add- views onto prev stack
          if (rail === prev) {
            new_stack = [rail, prev2, prev3];
          } else {
            new_stack = [rail, prev, prev2];
          }
        } else {
        new_stack = [rail, curr, prev];
      }
    }
    setIsExpanded(new_stack);
    context.crossfilterStore.setMapCovered(new_stack && new_stack.some(Boolean));
    // save state to restore on refresh
    const saveState =
      rail && rail.indexOf("add-") === 0 ? new_stack.slice(1) : new_stack;
    localStorage.setItem("explorer:expanded", JSON.stringify(saveState));
    // force recount when expanding — run unconditionally so first-ever expand also fetches counts
    refreshCount();
  };

  useEffect(() => {
    if(map) {
      refreshCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, context.chartsStore.taxonomy])

  const onClickAddFilters = (e) => onClickExpand("add-filters", e);
  const onClickExpandFilters = (e) => onClickExpand("filters", e);
  const onClickAddInsights = (e) => onClickExpand("add-insights", e);
  const onClickExpandInsights = (e) => onClickExpand("insights", e);

  const onClickCloseWidgetPicker = (ev) => {
    ev.stopPropagation();
    onClickExpand(isExpanded[1], ev);
    setMapControlsUI();
  };

  /*
  * keep track of the last 10 filters used
  */
  const updateRecentlyUsed = (chart_id) => {
    let _current = JSON.parse( localStorage.getItem(`explorer:recents:${companyId}`) ) || [];
    if (_current.includes(chart_id)) {
      return;
    }
    _current.unshift(chart_id);
    let remove_duplicates = [...new Set(_current)];
    let last_ten_saved = remove_duplicates.slice(0, 10);
    localStorage.setItem( `explorer:recents:${companyId}`, JSON.stringify(last_ten_saved) );  
  }

  const onClickAddFilter = (chart_id) => {
    context.crossfilterStore.add_empty_filter(chart_id);
    updateRecentlyUsed(chart_id);
  };

  const onClickAddInsight = (chart_id) => {
    context.crossfilterStore.add_widget(chart_id);
    updateRecentlyUsed(chart_id);
  };

  const onClickBuildModel = (ev) => {
    ev.stopPropagation();
    props.history.push("/model");
  };

  const onClickOrder = (ev) => {
    if (!hasLicenseFee) {
      setShowNeedLicense(true);
    } else if (context.crossfilterStore.count < minQuantity.current) {
      toggleMinOrderModal(ev);
      return;
    } else {
      ev.stopPropagation();
      context.crossfilterStore.set_missing_filters(false);
      props.history.push("/order");
    }
  };

  const onClickSaveAudience = (ev) => {
    let audience = selectedAudience;
    let selection_criteria_to_store = context.crossfilterStore.build_saved_selection_criteria(true);
    setDataFiltersHaveChanged(false);

    if (duplicatedName) {
      setDuplicatedNameModalIsOpen(true);
      return;
    }
    ev.stopPropagation();

    setSaved(false);
    setSaving(true);

    audience.filters = context.crossfilterStore.filters || {};
    audience.saved_selection_criteria = selection_criteria_to_store;
    audience.insights = context.crossfilterStore.widgets;
    audience.adhoc_points = context.crossfilterStore.adhoc_points;
    audience.location_type_ids = context.crossfilterStore.location_type_ids;
    audience.map_state = {
      map_center: context.crossfilterStore.map_center,
      map_zoom: context.crossfilterStore.map_zoom,
    };
    audience.count = context.crossfilterStore.count;
    audience.dedupe_level = context.crossfilterStore.dedupe;
    audience.complex_filters = complex
      ? {
          tree: complexQuery.tree,
          logic: complexQuery.logic,
        }
      : {};
    audience.is_complex = complex || false;
    audience.population_domain = explorerModule;


    context
      .command(audience.id ? "audience/update" : "audience/create", audience)
      .then((a) => {
        // When saving make sure to set state appropriately:
        lastAudienceState.current = a;
        savedAudience.current = a;
        context.crossfilterStore.save_audience(a);
        localStorage.setItem("am:audience:audience_state", LZString.compress(JSON.stringify(a)));
        localStorage.setItem("am:audience:lastid", JSON.stringify(a.id));
        setSelectedAudience(a);
        setSaving(false);
        setSaved(true);
        setEditing(false);
        context.audienceSaved.saved(true);
      });
  };

  const onMountMap = (map) => {
    context.crossfilterStore.map_enter(map);
    setMap(map);
  };

  const onUnmountMap = () => {
    context.crossfilterStore.map_leave();
    setMap(undefined);
  };

  const onDedupeLevelChange = (ev) => {
    if(context.crossfilterStore.dedupe === "Individual" && 
      (ev.target.value === "Household" || ev.target.value === "Address") && 
      context.crossfilterStore.count > dedupe_max_limit) {
        setDedupeErrorMessage(`Audience size must be less than ${dedupe_max_limit.toLocaleString()} to change uniqueness level. Please refine your audience and try again.`);
        setDedupeErrorMessagesIsOpen(true);
        return;
    }
    context.crossfilterStore.setDedupe(ev.target.value);
    setSelectedAudience({ ...selectedAudience, dedupe_level: ev.target.value });
  };

  useEffect(() => {
    setDedupeErrorMessagesIsOpen(false);
    if(loaded && taxonomyLoaded) {
      if(context.crossfilterStore.count > dedupe_max_limit && (lastAudienceState.current.dedupe_level === "Household" || lastAudienceState.current.dedupe_level === "Address")) {
        setDedupeErrorMessage(`Your audience size now exceeds ${dedupe_max_limit.toLocaleString()} so your uniqueness level has been reset to Individual.`)
        setDedupeErrorMessagesIsOpen(true);
        lastAudienceState.current.dedupe_level = "Individual";
      }
    }
  // eslint-disable-next-line
  }, [context.crossfilterStore.count, loaded, taxonomyLoaded])

  const onRemoveFilters = (config) => {
    context.crossfilterStore.remove_all_filters(config.id);
  };

  const onRemoveInsights = (config) => {
    context.crossfilterStore.remove_widget(config.id);
  };

  const onFilterDragStart = (filter_index, ev) => {
    ev.dataTransfer.setData("text/plain", JSON.stringify(filter_index));
    // setTimeout here due to chrome bug: https://groups.google.com/a/chromium.org/forum/?fromgroups=#!msg/chromium-bugs/YHs3orFC8Dc/ryT25b7J-NwJ
    setTimeout(() => setDraggingFilters(true), 20);
  };

  const onFilterDrop = (target_index, ev) => {
    const source_index = JSON.parse(ev.dataTransfer.getData("text/plain"));
    const filtered_charts_list = Object.entries(
      context.crossfilterStore.filters
    );
    const moving_chart = filtered_charts_list[source_index];
    filtered_charts_list[source_index] = null;
    filtered_charts_list.splice(target_index, 0, moving_chart);
    const updated_charts_list = filtered_charts_list.filter((c) => c !== null);
    const updated_charts = {};
    for (const [key, val] of updated_charts_list) {
      updated_charts[key] = val;
    }
    context.crossfilterStore.setFilters(updated_charts);
    setDraggingFilters(false);
  };

  const onFilterDragEnd = (_ev) => {
    setDraggingFilters(false);
  };

  const onInsightDragStart = (filter_index, ev) => {
    ev.dataTransfer.setData("text/plain", JSON.stringify(filter_index));
    // setTimeout here due to chrome bug: https://groups.google.com/a/chromium.org/forum/?fromgroups=#!msg/chromium-bugs/YHs3orFC8Dc/ryT25b7J-NwJ
    setTimeout(() => setDraggingInsights(true), 20);
  };

  const onInsightDrop = (target_index, ev) => {
    const source_index = JSON.parse(ev.dataTransfer.getData("text/plain"));
    const insight_charts = context.crossfilterStore.widgets.slice();
    const moving_chart = insight_charts[source_index];
    insight_charts[source_index] = null;
    insight_charts.splice(target_index, 0, moving_chart);
    const updated_charts = insight_charts.filter((c) => c !== null);
    context.crossfilterStore.setWidgets(updated_charts);
    setDraggingInsights(false);
  };

  const onInsightDragEnd = (_ev) => {
    setDraggingInsights(false);
  };

  const onHoverNameHandler = () => {
    setNameIsFocused(!nameIsFocused);
  };

  const checkForDuplicateName = (name) => {
    let found = false;
    context.query("audience/check_name", { name: name }).then((response) => {
      found =
        response.id && response.id !== 0 && selectedAudience.id !== response.id;
      setDuplicatedName(found);
    });
    return found;
  };

  const onEditAudienceName = (_ev) => {
    audienceNameRef && audienceNameRef.focus();
  };

  // Allow for some normal typing before running the check on duplicate name.
  const debounceNameSearch = debounce(
    (name) => checkForDuplicateName(name),
    500
  );

  const onAudienceNameChange = (value) => {
    const dupeName = debounceNameSearch(value);
    if (dupeName) {
      setDuplicatedName(true);
      return;
    }
    setSavedAudienceName(value);
    setSelectedAudience({ ...selectedAudience, name: value });
  };

  // Check for unsaved and call up modal dialog.
  const onClickNew = () => {
    if (!saved) {
      context.audienceSaved.unsavedAudience(() => onClickNewCallback);
    } else {
      onClickNewCallback();
    }
  };

  // Modal 'continue' callback. 
  const onClickNewCallback = () => {
    const zoomLevel = context.crossfilterStore.getDefaultMapZoom();
    localStorage.setItem("am:audience:map:center", JSON.stringify(context.crossfilterStore.companyHq));
    localStorage.setItem("am:audience:map:zoom", JSON.stringify(zoomLevel));
    clearExplorerState();
  };

  const clearExplorerState = () => {
    setSelectedAudience({});
    setSavedAudienceName("");
    setEditing(false);
    setComplex(false);
    setComplexQuery(null);
    setIsNewAudience(true);
    setIsExpanded("[]");
    lastAudienceID.current = "";
    lastAudienceState.current = {};
    localStorage.removeItem("explorer:layers:boundaries");
    localStorage.removeItem("am:audience:lastid");
    localStorage.removeItem("am:audience:audience");
    localStorage.removeItem("am:audience:audience_state");
    localStorage.removeItem("am:audience:filters");
    localStorage.removeItem("am:audience:location_type_ids");
    localStorage.removeItem("am:audience:adhoc_points");
    context.crossfilterStore.setFilters([]);
    context.crossfilterStore.remove_complex_filters();
    context.crossfilterStore.restoreFromAudience("clear_all");
  }

  const getGeoboundaryName = async (ids, type) => {
      const n = await context.crossfilterStore.fetchGeoBoundaryNames(ids, type);
      return n;
  }
  
  const createComplexTree = async (_filters_raw, _charts) => {
    //Root of complex filter tree
    let new_tree = {};
    new_tree.id = crypto.randomUUID();
    new_tree.type = "group";
    new_tree.properties = {};
    new_tree.properties.conjunction = "AND";
    new_tree.properties.not = false;
    new_tree["children1"] = {};

    let filters_tree = {};
    filters_tree.type = "group";
    filters_tree.properties = {};
    filters_tree.properties.conjunction = "AND";
    filters_tree.properties.not = false;
    filters_tree["children1"] = {};

    let locations_tree = {};
    locations_tree.type = "group";
    locations_tree.properties = {};
    locations_tree.properties.conjunction = "OR";
    locations_tree.properties.not = false;
    locations_tree["children1"] = {};

    let geo_boundaries_tree = {};
    geo_boundaries_tree.type = "group";
    geo_boundaries_tree.properties = {};
    geo_boundaries_tree.properties.conjunction = "OR";
    geo_boundaries_tree.properties.not = false;
    geo_boundaries_tree["children1"] = {};

    // Remove location types before interacting with filters
    const _filters = Object.fromEntries(
      Object.entries(_filters_raw).filter(([key]) => key !== "locations")
    );

    // Filter out geo-boundaries filters
    const geoTopLevel = Object.fromEntries(Object.entries(_filters));
    const geo_boundaries = Object.entries(geoTopLevel).map(([k, v]) => {
      if(_charts[k] && _charts[k].uiType === "geo-boundaries") {
        return [k, v];
      }
      return null;
    });

    // Get ID lists for each geo-boundary type
    let geo_ids = {};
    geo_boundaries?.forEach((k) => { 
      if (!k) return;
      geo_ids[k[0]] = [];
      k[1]?.forEach((v) => { 
        if (v.value) {
          geo_ids[k[0]].push(v.value);
        }
      });
    });

    // Get geo-boundary id:names in bulk
    let geo_names = {};
    const geoPromises = Object.entries(geo_ids).map(async ([k, v]) => {
      if (v.length) {
        return [k, await getGeoboundaryName(v, "_" + k)];
      }
      return null;
    });
    const resolvedGeoNames = await Promise.all(geoPromises);
    resolvedGeoNames.forEach((result) => {
      if (result) {
        const [k, name] = result;
        geo_names[k] = name;
      }
    });

    // Loop through filters and build the complex filter tree
    for (const filter of Object.entries(_filters)) {
      if (filter[0] === "undefined") { continue; }
      let is_negated = false;
      let values = [];
      let asyncValues = [];
      // For geo-boundaries, we need to fetch the names asynchronously
      // and build the asyncValues array
      for (const element of filter[1]) {
        is_negated = element.is_negated;
        values.push(element.value);
        let name;
        if (_charts[filter[0]].uiType === "geo-boundaries" && !filter[0].endsWith("zip")) {
          name = geo_names[filter[0]] ? geo_names[filter[0]][element.value] : element.friendly_name;
          asyncValues.push({ key: element.value, value: element.value, children: name });
        } else {
          name = element.value || element.friendly_name;
          asyncValues.push({ key: element.value, value: name });
        }
      }
    
      let properties = {};
      
      let name = _charts[filter[0]].ds + "__" + _charts[filter[0]].id;
      properties.field = name;
      properties.opertor = "equal";
      properties.value = [values.length ? values : null];
      properties.asyncListValues = asyncValues;
      properties.valueSrc = ["value"];
      properties.valueType = ["multiselect"];
      properties.operator = "multiselect_equals";
      let new_filter = {};
      if (is_negated) {
        let negated_filter_group = {};
        negated_filter_group.type = "group";
        negated_filter_group.properties = {};
        negated_filter_group.properties.conjunction = "AND";
        negated_filter_group.properties.not = true;
        let negated_uuid = crypto.randomUUID();
        negated_filter_group["children1"] = {};
        negated_filter_group["children1"][negated_uuid] = {};
        negated_filter_group["children1"][negated_uuid].properties = properties;
        negated_filter_group["children1"][negated_uuid].type = "rule";
        new_filter = negated_filter_group;
      }
      new_filter.type = "rule";
      new_filter.properties = properties;
      let uuid = crypto.randomUUID();
      if (
        [
          known_chart_ids.states,
          known_chart_ids.zipcodes,
          known_chart_ids.counties,
          known_chart_ids.congressional_districts,
          known_chart_ids.cbsa
        ].includes(filter[0])
      ) {
        geo_boundaries_tree["children1"][uuid] = new_filter;
      } else if (filter[0].startsWith("location_type_")) {
        locations_tree["children1"][uuid] = new_filter;
      } else {
        filters_tree["children1"][uuid] = new_filter;
      }
    };

    //Build the logic tree to look
    // ( filters AND locations AND geo boundaries)
    let have_locations = Object.keys(locations_tree["children1"]).length > 0;
    let have_geo_boundaries =
      Object.keys(geo_boundaries_tree["children1"]).length > 0;
    let have_filters = Object.keys(filters_tree["children1"]).length > 0;

    let total_filters = 0;
    if (have_locations) {
      total_filters += 1;
    }
    if (have_geo_boundaries) {
      total_filters += 1;
    }
    if (have_filters) {
      total_filters += 1;
    }

    if (total_filters === 0) {
      return new_tree;
    } else if (total_filters === 1) {
      if (have_filters) {
        return filters_tree;
      } else if (have_locations) {
        return locations_tree;
      } else {
        return geo_boundaries_tree;
      }
    } else {
      //more than one
      if (have_filters) {
        let uuid = crypto.randomUUID();
        new_tree["children1"][uuid] = filters_tree;
      }
      if (have_locations) {
        let uuid = crypto.randomUUID();
        new_tree["children1"][uuid] = locations_tree;
      }
      if (have_geo_boundaries) {
        let uuid = crypto.randomUUID();
        new_tree["children1"][uuid] = geo_boundaries_tree;
      }
    }

    return new_tree;
  };

  const onClickComplexFilter = async (ev) => {
    ev.stopPropagation();
    setComplexModified(complex === complexModified);
    //Convert filters to complex filters and set
    let query = {};
    query.tree = await createComplexTree(
      context.crossfilterStore.filters,
      context.chartsStore.charts
    );

    if(!query.tree) {
      setConvertToComplexModalIsOpen(false);
      setConvertToComplexModalMatchLevelIsOpen(false)
      return;
    }

    query.logic = buildLogic(query.tree);

    // give priority to crossfilterStore until it is done
    setTimeout(() => { 
      setComplexQuery(query);
      setComplex(true);
    }, 250);

    clearSimpleFiltersIfPresent();
    setConvertToComplexModalIsOpen(false);
    setConvertToComplexModalMatchLevelIsOpen(false)
  };

  const onRevertToSimpleFilter = () => {
    setRevertToSimpleModalIsOpen(false);
    setComplex(false);
    setComplexQuery(null);
    context.crossfilterStore.remove_complex_filters();
    setTimeout(() => { window.location.href = "/explorer"; }, 1000);
  };

  const clearSimpleFiltersIfPresent = () => {
    if (Object.entries(context.crossfilterStore.filters).length > 0) {
      context.crossfilterStore.setFilters({});
      context.crossfilterStore.runCountRefresh();
      setMapControlsUI();
    }
  };

  const changeComplexQuery = (jsonTree, jsonOutput) => {
    clearSimpleFiltersIfPresent();
    setComplexQuery({ tree: jsonTree, logic: jsonOutput.logic });
  };

  const applyComplexFilter = () => {
    if (!Object.keys(complexQuery).length) {return}
    setComplex(true);
    if("logic" in complexQuery) {
      context.crossfilterStore.set_complex_filters(complexQuery);
    } else {
      let logic = buildLogic(complexQuery.tree);
      context.crossfilterStore.set_complex_filters({tree: complexQuery.tree, logic: logic});
    }
    clearSimpleFiltersIfPresent();
    context.crossfilterStore.remove_all_adhoc_points();
    setComplexModified(!complexModified);
  };

  // build the complex filter's logic json when needed
  const buildLogic = (_query) => {
    let logic = {"and": []};
    if(!_query) {
      setComplex(false);
      return;
    }

    let logic_entries = Object.entries(_query.children1);
    logic_entries && logic_entries.length && logic_entries.forEach((_selection) => {
      logic.and.push(
        {
          "all": [
              { "var": _selection[1].properties.field },
              { "in": _selection[1].properties.value  }
          ]
        }
      ); 
    })
    return logic;
  }
  
  const toggleClearAllFiltersModal = (e) => {
    if (Object.entries(!context.crossfilterStore.filters).length) {
      return;
    }
    setClearAllFiltersModalIsOpen(!clearAllFiltersModalIsOpen);
  };

  const toggleClearAllInsightsModal = (e) => {
    if (!context.crossfilterStore.widgets.length) {
      return;
    }
    setClearAllInsightsModalIsOpen(!clearAllInsightsModalIsOpen);
  };

  const toggleMinOrderModal = (e) => {
    e.preventDefault();
    setOrderBelowMinModalIsOpen(!orderBelowMinModalIsOpen);
  };

  const toggleDuplicateNameModal = (e) => {
    e.preventDefault();
    setDuplicatedNameModalIsOpen(!duplicatedNameModalIsOpen);
  };

  const toggleRevertToSimpleModal = (e) => {
    e.preventDefault();
    setRevertToSimpleModalIsOpen(!revertToSimpleModalIsOpen);
  };





  function checkAllMatchValue(filters) {
    for (const key in filters) {
        const items = filters[key];
        
        // Check if items is an array
        if (Array.isArray(items)) {
            for (const item of items) {
                // Check if this item has 'all_match_value' property
                if ('all_match_value' in item) {
                    // If it exists and is NOT "individual", return true
                    if (item.all_match_value !== 'individual') {
                        return true;
                    }
                }
            }
        }
    }

    return false;
  }

  const toggleConvertToComplexModal = (e) => {
    e.preventDefault();
    if (context.crossfilterStore.adhoc_points.length) {
      setConvertToComplexModalIsOpen(!convertToComplexModalIsOpen);
    } else if(checkAllMatchValue(filters)) {
      setConvertToComplexModalMatchLevelIsOpen(true);
    } else {
      onClickComplexFilter(e);
    }
  };

  const toggleDeDupeDropdown = (e) => {
    e.preventDefault();
    setDedupeDropDownIsOpen(!dedupeDropDownIsOpen);
  };

  const togglePageActionDropdown = (e) => {
    e.preventDefault();
    setPageActionDropDownIsOpen(!pageActionDropDownIsOpen);
  };

  const toggleMissingDataModal = (e) => {
    setMissingDataModalIsOpen(!missingDataModalIsOpen);
  }

  // Check for an empty audience
  const isEmptyAudience = () => {
    if (isLoading || !context.crossfilterStore.audienceLoaded) return false;
    const insights = Object.keys(context.crossfilterStore.widgets);
    const filters = Object.values(context.crossfilterStore.filters);

    let hasFilters = false;
    let hasInsights = false;
    let hasComplexFilters = false;
    let hasEmptyComplexFilters = false;
    let emptyAudience = false;

    // any insights added?
    hasInsights = insights.length > 0 ? true : false;

    // any filters added?
    filters.forEach((key) => {
      if (key.length > 0) {
        hasFilters = true;
        return;
      }
    });

    // any complex filters?
    hasComplexFilters = complexQuery && complexQuery.tree && Object.keys(complexQuery.tree.children1).length;

    // any complex filters with empty fields?
    if (hasComplexFilters) {
      const someEmpty = hasEmptyComplexFields();
      if(someEmpty) {
        return true;
      }
    }

    if (
      (!hasFilters && !hasInsights && !hasComplexFilters)
    ) {
      emptyAudience = true;
      !empty && setEmpty(true);
    } else if(hasComplexFilters && hasEmptyComplexFilters) {
      emptyAudience = true;
      !empty && setEmpty(true);
    } else {
      emptyAudience = false;
      empty && setEmpty(false);
    }
    return emptyAudience;
  };

  const hasEmptyComplexFields = () => {
    let _selections = (complexQuery.tree && complexQuery.tree.children1) ? Object.entries(complexQuery.tree.children1) : null;
    let hasEmpty = false;
    let _find_null1 = `"value":[null]`;
    let _find_null2 = `"value":[]`;

    if (
      JSON.stringify(_selections).includes(_find_null1) ||
      JSON.stringify(_selections).includes(_find_null2)) {
      hasEmpty = true;
      return true;
    }

    if(_selections && _selections.length) {
      _selections.forEach((item) => {
        let _item = item[1].properties.value;
        if(_item) {
          if (!_item.length) {
            hasEmpty = true;
          } else {
            let find_empty = _item.some((value) => {
              if (
                (value === null ||
                value === undefined ||
                  !value.length)
                // legacy check for any complex filter values with the null value inserted.
                && value && !value.hasOwnProperty('var')
              ) {
                return true;
              } else {
                return false;
            }
            });
            find_empty && (hasEmpty = true);
          }
        } 
      });
    } else {
      hasEmpty = true;
    }
    return hasEmpty;
  }

  const setMapControlsUI = () => {
    const access = context.appState.userCan;
    let mainMapLayers = [
      <MapSearch />,
      <MapLayers showLocations={!complex && access("has_explorer_edit")} />,
    ];
    if (!complex && access("has_explorer_edit")) {
      mainMapLayers.push(<MapAdHoc />);
    }
    mainMapLayers.push(<MapPointsConfigurator />);

    if(!isEqual(mapControls, mainMapLayers)) {
      setMapControls(mainMapLayers);
    }
  };

  const downloadCountsInfoToggle = () => { 
    if(complex) {
      setDownloadCountsInfoOpen(!downloadCountsInfoOpen); 
    }
  }

  const onDownloadInsights = (e, _download) => {
    e.preventDefault();

    if(_download === "Insights Counts") {
      setInsightCountsOnly(true);
    } else {
      let _report_data = {
        "company_name": context.appState.activeCompany.name,
        "audience_name": "id" in selectedAudience ? selectedAudience.name : "Untitled",
        "user_name": context.appState.identity.user.name,
        "audience_size": context.crossfilterStore.count || 0,
        "is_complex": complex,
        "filters": context.crossfilterStore.getFiltersReportData(),
        "complex_filters": context.crossfilterStore.complexFilters,
        "insights": context.crossfilterStore.getInsightsReportData(insights)
      }
      window.sessionStorage.setItem('am:insight-report', JSON.stringify(_report_data));
      props.history.push('/insights-pdf-report');
    }
  }

  const handleChartsHaveUpdates = () => {
    setMapControlsUI();
  }
  useEffect(() => {
    setReportReady(false);
    let _insights = context.crossfilterStore.widgets;
    if(_insights && _insights.length && loaded && !isLoading && (context.crossfilterStore.count > 0)) {
      setTimeout(() => {
        setReportReady(true);
      }, 1000);
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.crossfilterStore.count, context.crossfilterStore.widgets, loaded])

  useEffect(() => {
    if(insightCountsOnly) {
      onClickDownload();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insightCountsOnly])

  // Make sure to update the complex fields when the complex query is set.
  useEffect(() => {
    if( loaded && complex && !complexFields) {
      update_complex_fields();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complexFields, complex, savedAudience, loaded])

  useEffect(() => {
    if( isAudienceSaved !== context.audienceSaved.isSaved) {
      setIsAudienceSaved(context.audienceSaved.isSaved);
    }
  })

  useEffect(() => {
    if( (selectedAudience.id || props.args.audience) && isAudienceSaved ) {
      setShowCompareLink(true);
      setCurrentAudienceId(selectedAudience.id || props.args.audience);
    } else {
      setShowCompareLink(false);
      setCurrentAudienceId("");
    }
  }, [isAudienceSaved, selectedAudience, props.args.audience])

  useEffect(() => {
    if(explorerModule && filters) {
      if (explorerModule && filters) {
        const filterValues = Object.values(filters).flat();

        const getComplexRuleFields = (node) => {
          if (!node) return [];
          if (node.type === 'rule') return node.properties?.field ? [node.properties.field] : [];
          return Object.values(node.children1 || {}).flatMap(getComplexRuleFields);
        };
        const complexRuleFields = complex && complexQuery?.tree
          ? getComplexRuleFields(complexQuery.tree)
          : [];

        if (explorerModule === 'movers') {
          const hasMovers = filterValues.some(f => f.series?.includes(window.movers_population_domain))
            || complexRuleFields.some(f => f.includes(window.movers_population_domain));
          setNoMoversSelection(!hasMovers);
        } else if (explorerModule === 'life_events') {
          const hasLifeEvent = filterValues.some(f => f.series?.includes(window.life_events_population_domain))
            || complexRuleFields.some(f => f.includes(window.life_events_population_domain));
          setNoLifeEventSelection(!hasLifeEvent);
        } else {
          setNoMoversSelection(true);
          setNoLifeEventSelection(true);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [explorerModule, filters, complex, complexQuery])

  const prevModuleRef = useRef(null);

  useEffect(() => {
    // skip on first mount
    if (prevModuleRef.current === null) {
      prevModuleRef.current = explorerModule;
      return;
    }
 
    // clean up explorer data
    if (prevModuleRef.current !== explorerModule) {
      onClickNewCallback();
    }

    prevModuleRef.current = explorerModule;
  // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [explorerModule]);

  const output = () => {
    // User permission callback.
    const access = context.appState.userCan;

    let saveButtonLabel = "";
    let saveButtonHandler;
    // Save Button Management
    if (!selectedAudience.id) {
      saveButtonLabel = "Save New Audience";
    } else {
      saveButtonLabel = "Update Audience ";
    }

    if (editing && selectedAudience.name) {
      saveButtonHandler = onClickSaveAudience;
    } else if (!selectedAudience.name) {
      saveButtonHandler = onEditAudienceName;
    } else {
      saveButtonHandler = onClickSaveAudience;
    }

    let nameTooShort = true;
    if (selectedAudience.name && selectedAudience.name.length > 40) {
      nameTooShort = false;
    }

    // check for filters
    let hasFilters = false;
    const f = Object.values(context.crossfilterStore.filters);
    f.forEach((key) => {
      if (key.length > 0) {
        hasFilters = true;
        return;
      }
    });

    // any complex filters?
    hasFilters = (complexQuery && Object.keys(complexQuery).length) ? true : hasFilters;

    const hasLicense = (value) => {
      setHasLicenseFee(value || false);
    };

    const getNameValue = () => {
      if( lastAudienceState && lastAudienceState.current && lastAudienceState.current.name ) {
        return lastAudienceState.current.name;
      } else {
        return "";
      }
    }

    const checkIfReadyToOrder = () => {
      if(empty || !hasFilters) {
        return true;
      } else {
        if (explorerModule === 'movers') {
          // check if it has movers selection?
          return noMoversSelection;
        } else if (explorerModule === 'life_events') {
          // check if it has life selection?
          return noLifeEventSelection;
        } else {
          return false; // consumers
        }
      }
    }

    const header = (
      <div className="explorer-header">
        <div className="explorer-page-title">
          {(explorerModule === "consumers") && <h1><i className="fa-solid fa-globe" /> CONSUMERS</h1>}
          {(explorerModule === "movers") && <h1><i className="fa-solid fa-truck" /> MOVERS</h1>}
          {(explorerModule === "life_events") && <h1><i className="fa-regular fa-calendar-days" /> LIFE EVENTS</h1>}
        </div>
        
        { (access("audience_edit") || access("audience_create")) &&
          <>
            <div className="header-display-left">
              <h1>
                <Form className="special-edit" onSubmit={e => e.preventDefault()}>
                  <div className="name-input-wrap">
                    <InputGroup>
                      <TextInput
                        className={
                          empty
                            ? nameTooShort
                              ? "audience-input-field disabled short"
                              : "audience-input-field disabled"
                            : nameTooShort
                            ? "audience-input-field short"
                            : "audience-input-field"
                        }
                        type="text"
                        placeholder={!empty ? "Enter Audience Name" : ""}
                        disabled={empty || !access("audience_edit")}
                        onMouseOver={onHoverNameHandler}
                        onMouseLeave={onHoverNameHandler}
                        onChange={onAudienceNameChange}
                        onClick={onEditAudienceName}
                        innerRef={(el) => setAudienceNameRef(el)}
                        value={getNameValue}
                      />
                    </InputGroup>
                  </div>
                </Form>
              </h1>
            </div>


            {duplicatedName && (
              <span className="audience-save name-warning">
                <i className="bi bi-exclamation-triangle"></i> Name already exists
              </span>
            )}
            {!empty && !selectedAudience.name && (
              <span className="audience-save name-warning">
                <sup>*</sup>Required
              </span>
            )}
            {saved && !context.audienceSaved.isEdited && (
              <span className="save-success">
                <i className="fa fa-check"></i>Saved
              </span>
            )}
            {saving && (
              <span>
                <div className="loader"></div>
              </span>
            )}
          </>
        }

          <i className="spacer" />
          <div
            className={classNames("header-display-right", {
              hide: nameIsFocused && !nameTooShort,
            })}
          >
            <label>Audience Size:</label>
            <TweenedNumber
              className="quick-count main-count"
              fullNumber
              value={context.crossfilterStore.count || 0}
            />
            {(access("has_explorer_edit") ||
              access("has_explorer_view") ||
              access("audience_edit") ||
              access("order_create") ||
              access("model_create")) && (
              <Dropdown
                className="dd-page-actions"
                isOpen={pageActionDropDownIsOpen}
                toggle={togglePageActionDropdown}
                onMouseEnter={togglePageActionDropdown}
                onMouseLeave={togglePageActionDropdown}
              >
                <DropdownToggle
                  size="sm"
                  caret
                  className={classNames({
                    promote: editing,
                  })}
                  disabled={empty}
                >
                  Audience Actions
                </DropdownToggle>
                <DropdownMenu>
                    <>
                      <DropdownItem header>Audience Options</DropdownItem>
                      {access("audience_edit" || access("audience_create")) && (
                        <>
                          <DropdownItem onClick={onClickNew}>
                            <i className="bi bi-file-earmark-plus"></i>New {formatPopulationDomain(explorerModule)} Audience
                          </DropdownItem>

                          <DropdownItem
                            className={classNames({ promote: editing, })}
                            disabled={empty}
                            onClick={saveButtonHandler}
                          >
                            <i className="bi bi-save2"></i>
                            {saveButtonLabel}
                          </DropdownItem>
                        </>
                      )}
                      <DropdownItem
                        disabled={empty}
                        onClick={complex ? () => setDownloadCountsInfoOpen(false) : onClickDownload}
                        id="download_counts"
                        onMouseOut={() => setDownloadCountsInfoOpen(false)}
                      >
                        <i className="bi bi-filetype-csv"></i>
                        Download Counts
                      </DropdownItem>                      
                      <Popover
                        flip
                        fade
                        trigger="hover"
                        onMouseOut={() => setDownloadCountsInfoOpen(false)}
                        target="download_counts"
                        isOpen={downloadCountsInfoOpen}
                        toggle={downloadCountsInfoToggle}
                      >
                        <PopoverHeader>Complex Filters</PopoverHeader>
                        <PopoverBody>
                          <i className="bi bi-info-circle"/>&nbsp; Complex Filters can NOT be applied or included in a count report
                        </PopoverBody>
                      </Popover>

                      <div title={!reportReady ? "Report Not Available" : ""}>
                        <DropdownItem disabled={!reportReady} onClick={(e) => onDownloadInsights(e, "Insights Report")}>
                          <i className="bi bi-printer"/>Insights Report
                        </DropdownItem>
                      </div>
                      
                      {access("audience_edit" || access("audience_create")) && (
                        <DropdownItem onClick={() => props.history.push("/audiences")}>
                          <i className="bi bi-folder2-open"></i>My Audiences
                        </DropdownItem>
                      )}

                    </>
                  {(access("order_create") || access("model_build")) && (
                    <DropdownItem header>Audience Next Steps</DropdownItem>
                  )}
                  {access("order_create") && (
                    <DropdownItem
                      onClick={onClickOrder}
                      disabled={checkIfReadyToOrder()}
                    >
                      <i className="bi bi-send"></i>Order
                    </DropdownItem>
                  )}
                  {access("model_create") && (
                    <DropdownItem
                      onClick={onClickBuildModel}
                      disabled={empty || !hasFilters || (explorerModule !== "consumers")}
                    >
                      <i className="bi bi-person-bounding-box"></i>Build Model
                    </DropdownItem>
                  )}
                  {access("audience_view") && (
                    <DropdownItem 
                      onClick={() => props.history.push("/compare-audiences#explorer_id="+currentAudienceId)}
                      disabled={!showCompareLink || (explorerModule !== "consumers")}
                    >
                      <i className="bi bi-graph-up"></i>Compare Audiences
                    </DropdownItem>
                  )}
                  {empty && (
                    <Alert className="menu-note">
                      <p>
                        <i className="bi bi-lightbulb"></i>This Audience is
                        currently empty. Add some filters or insights.
                      </p>
                    </Alert>
                  )}
                  {!empty && !hasFilters && (
                    <Alert className="menu-note">
                      <p>
                        <i className="bi bi-lightbulb"></i>This Audience has no filters applied. To be able to place an order or create a model, add some filter selections.
                      </p>
                    </Alert>
                  )}
                  {!empty && (explorerModule === "life_events") && noLifeEventSelection && (
                    <Alert color="warning" className="menu-note">
                      <p>
                        <i className="bi bi-exclamation-diamond"></i>Please select a Life Event to continue.
                      </p>
                    </Alert>
                  )}
                  {!empty && (explorerModule === "movers") && noMoversSelection && (
                    <Alert color="warning" className="menu-note">
                      <p>
                        <i className="bi bi-exclamation-diamond"></i>Please select a Move Event to continue.
                      </p>
                    </Alert>
                  )}
                </DropdownMenu>
              </Dropdown>
            )}
          </div>
      </div>
    );

    const clearAllFiltersModal = (
      <>
        <Modal
          centered
          isOpen={clearAllFiltersModalIsOpen}
          toggle={(e) => toggleClearAllFiltersModal(e)}
          backdrop
        >
          <ModalHeader toggle={toggleClearAllFiltersModal}>
            Clear all filters?
          </ModalHeader>
          <ModalBody>
            <p>All of your filters and settings will be lost.</p>
          </ModalBody>
          <ModalFooter>
            <Button className="promote" onClick={toggleClearAllFiltersModal}>
              Cancel
            </Button>
            <Button onClick={handleClearAllFilters}>Clear Filters</Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const clearAllInsightsModal = (
      <>
        <Modal
          centered
          isOpen={clearAllInsightsModalIsOpen}
          toggle={(e) => toggleClearAllInsightsModal(e)}
          backdrop
        >
          <ModalHeader toggle={toggleClearAllInsightsModal}>
            Clear all insights?
          </ModalHeader>
          <ModalBody>
            <p>All of your insights will be lost.</p>
          </ModalBody>
          <ModalFooter>
            <Button className="promote" onClick={toggleClearAllInsightsModal}>
              Cancel
            </Button>
            <Button onClick={handleClearAllInsights}>Clear Insights</Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const missingDataDetails = () => {
      if (!missingData) return;
      const md = missingData;
      return (
        <>
          {
            md.missing_features && md.missing_features.length > 0 && 
            <div className="missingdata features">
               <h5><strong>Missing features:</strong></h5>
               {md.missing_features.map(feature => {
                 return (
                   <ul key={feature.label}>
                     <li>{feature.label}</li>
                   </ul>
                 )
               })}
            </div>
          }
          {
            md.missing_values && md.missing_values.length > 0 && 
            <div className="missingdata filters">
                <h5><strong>Missing filter values by feature:</strong></h5>
                {md.missing_values.map(feature => {
                  return (
                    <ul key={feature.label}>
                      <strong>{feature.label}</strong>
                      {feature.values.map(value => { 
                        return (
                          <li key={value.label}>
                            {value.label}
                          </li>
                        )
                      })}
                    </ul>
                  )
                })}
            </div>
          }
        </>
      );
    }

    const missingDataModal = (
      <>
        <Modal
          centered
          isOpen={missingDataModalIsOpen}
          toggle={(e) => toggleMissingDataModal(e)}
          size="lg"
          backdrop
        >
          <ModalHeader toggle={toggleMissingDataModal}>
            <i className="bi bi-exclamation-triangle-fill"></i> Missing Features or Filters Since Last Save
          </ModalHeader>
          <ModalBody>
            <p>{missingDataDetails()}</p>
          </ModalBody>
          <ModalFooter>
            <Button onClick={toggleMissingDataModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const orderBelowMinModal = (
      <>
        <Modal
          centered
          isOpen={orderBelowMinModalIsOpen}
          toggle={(e) => toggleMinOrderModal(e)}
          backdrop
        >
          <ModalHeader toggle={toggleMinOrderModal}>
            Audience Size is Too Small
          </ModalHeader>
          <ModalBody>
            <p>
              Your current audience count is below the minimum allowed value for
              an order <strong>({minQuantity.current})</strong>.
            </p>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-lightbulb"></i>
              <div>
                Increase your total audience size by changing your applied
                filters.
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button onClick={toggleMinOrderModal}>Close</Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const duplicateNameModal = (
      <>
        <Modal
          centered
          isOpen={duplicatedNameModalIsOpen}
          toggle={(e) => toggleDuplicateNameModal(e)}
          backdrop
        >
          <ModalHeader toggle={toggleDuplicateNameModal}>
            This Audience Name Already Exists
          </ModalHeader>
          <ModalBody>
            <p>This audience name has already been used.</p>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-lightbulb"></i>
              <div>Choose a new name for your audience before saving.</div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button onClick={toggleDuplicateNameModal}>Close</Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const revertToSimpleWarningModal = (
      <>
        <Modal
          centered
          isOpen={revertToSimpleModalIsOpen}
          toggle={(e) => toggleRevertToSimpleModal(e)}
          backdrop
        >
          <ModalHeader toggle={toggleRevertToSimpleModal}>
            Revert to Simple Filters?
          </ModalHeader>
          <ModalBody>
            <p>Your complex filters will be lost.</p>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-lightbulb"></i>
              <div>
                Consider saving your audience and making a copy or new audience
                from the Audience Page.
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button className={" promote"} onClick={toggleRevertToSimpleModal}>
              Cancel
            </Button>
            <Button onClick={onRevertToSimpleFilter}>Continue</Button>
          </ModalFooter>
        </Modal>
      </>
    );
    const convertToComplexFiltersWarningModal = (
      <>
        <Modal
          centered
          isOpen={convertToComplexModalIsOpen}
          toggle={(e) => toggleConvertToComplexModal(e)}
          backdrop
        >
          <ModalHeader toggle={toggleConvertToComplexModal}>
            Convert to Complex Filters?
          </ModalHeader>
          <ModalBody>
            <p>
              Any map locations will be removed. Other filters will be converted
              into complex filters.
            </p>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-lightbulb"></i>
              <div>
                Consider saving your audience and making a copy or new audience
                from the Audience Page.
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button
              className={" promote"}
              onClick={toggleConvertToComplexModal}
            >
              Cancel
            </Button>
            <Button onClick={onClickComplexFilter}>Continue</Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const convertToComplexFiltersMatchLevelWarningModal = (
      <>
        <Modal centered isOpen={convertToComplexModalMatchLevelIsOpen} backdrop>
          <ModalHeader>
            Convert to Complex Filters?
          </ModalHeader>
          <ModalBody>
            <p>
              Any map locations will be removed. Other filters will be converted
              into complex filters.
            </p>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-exclamation-triangle-fill"></i>
              <div>
                Warning: Complex filters only support Individual Level Matching. All inclusions or exclusions made at the Household or Address level will be reverted to Individual Level.
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button className={" promote"} onClick={() => setConvertToComplexModalMatchLevelIsOpen(false)}>
              Cancel
            </Button>
            <Button onClick={onClickComplexFilter}>Continue</Button>
          </ModalFooter>
        </Modal>
      </>
    );

    const showDedupeErrorMessages = (
      <>
        <Modal centered isOpen={dedupeErrorMessagesIsOpen} backdrop>
          <ModalHeader>
            Uniqueness Level
          </ModalHeader>
          <ModalBody>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-info-circle-fill"></i>
              <div>
                {dedupeErrorMessage}
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button className={" promote"} onClick={() => setDedupeErrorMessagesIsOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );

    // Leave for now - see comment below
    // const summarize = summarize;

    const filtered_charts = Object.keys(context.crossfilterStore.filters);
    const insight_charts = context.crossfilterStore.widgets || [];
    const expanded = isExpanded[0];

    if (isLoading) {
      return (
        <div className="loader-container">
          <ProgressLoader />
        </div>
      );
    }

    return (
      <div
        id="explorer"
        className={classNames("explorer-page", "page", {
          "expanded-filters": expanded === "filters",
          "expanded-insights": expanded === "insights",
        })}
      >
        <div className="list-header sticky-page-header">
          {header}
        </div>
        {revertToSimpleWarningModal}
        {convertToComplexFiltersWarningModal}
        {convertToComplexFiltersMatchLevelWarningModal}
        {orderBelowMinModal}
        {duplicateNameModal}
        {clearAllFiltersModal}
        {clearAllInsightsModal}
        {missingDataModal}
        {showDedupeErrorMessages}
        <div className="rails">
          {/*****
           * Filters Rail
           */}
          <div
            className={classNames("filters-rail", {
              "is-adding": expanded === "add-filters",
              "is-dragging": draggingFilters,
            })}
          >
            <header>
              <h2>Filters</h2>
              <HelpTip
                id="filters-general"
              />
              {/* Leave this for now in case people actually use it
                {access('audience_edit') &&
                  <Button
                    className="toggle"
                    title={summarize ? "Graph View" : "Summary View"}
                    onClick={this.onClickViewMode}
                  >
                    <i
                      className={classNames(
                        "fa",
                        summarize ? "fa-chart-bar" : "fa-list-ul"
                      )}
                    />
                  </Button>
                } */}
              <i className="spacer" />
              {access("has_explorer_edit") && (
                <div className="add-remove">
                  <Button
                    color="link"
                    className="clear-all"
                    title="Clear All Filters"
                    onClick={toggleClearAllFiltersModal}
                  >
                    <i className="bi bi-x"></i>clear all
                  </Button>
                  <Button
                    size="sm"
                    className="add"
                    title="Add Filter"
                    onClick={onClickAddFilters}
                  >
                    <i className="fa fa-plus" />
                    Filter
                  </Button>
                </div>
              )}
              <Button
                className="expand"
                title="Expand Filters View"
                onClick={onClickExpandFilters}
              >
                <i className="fa fa-expand" />
              </Button>
            </header>

            <div className="content">
              {access("has_explorer_edit") && (
                <figure className="chart-widget is-crossfiltered is-filterable count-widget persontype-chart is-filtered">
                  <figcaption className="heading mb-1" draggable="true">
                    Uniqueness Level<i className="spacer"></i>
                  </figcaption>
                  <Dropdown
                    className="dd-dedupe"
                    isOpen={dedupeDropDownIsOpen}
                    toggle={toggleDeDupeDropdown}
                  >
                    <DropdownToggle size="sm" caret color="light">
                      {context.crossfilterStore.dedupe?.replace(/^(LE_|MV_)/, '')}
                    </DropdownToggle>
                    <DropdownMenu value={context.crossfilterStore.dedupe}>
                      {context.crossfilterStore.dedupeLevels.map((l) => (
                        <DropdownItem
                          onClick={(e) => {
                            onDedupeLevelChange(e);
                          }}
                          key={l}
                          value={l}
                        >
                          {l}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </figure>
              )}
              <DropZone onDrop={onFilterDrop.bind(this, 0)} />
              {!complex &&
                <>
                <Alert
                isOpen={!complex && dataFiltersHaveChanged && !expanded}
                color="warning"
                className="d-flex empty-filters"
              >
                <i className="bi bi-exclamation-triangle-fill"></i>
                <div>
                    <p>Since the last time this audience was saved, one or more of the filters chosen are no longer available.</p>
                    <Button
                      size="sm"
                      color="link"
                      className="alert-link"
                      onClick={toggleMissingDataModal}
                    >
                      More details
                    </Button>
                  </div>
              </Alert>
                <div className="chart-list">
                  {filtered_charts.map((chart_id, i) => (
                    <React.Fragment key={chart_id}>
                      <Chart
                        chart_id={chart_id}
                        chart_key={i}
                        crossfilter="true"
                        onRemove={onRemoveFilters}
                        map={map}
                        loaded={(context.crossfilterStore.audienceLoaded && loaded && !isLoading).toString()}
                        viewOnly={!access("has_explorer_edit")}
                        allowDownload
                        draggable={access("has_explorer_edit")}
                        onDragStart={onFilterDragStart.bind(this, i)}
                        onDragEnd={onFilterDragEnd}
                      />
                      <DropZone onDrop={onFilterDrop.bind(this, i + 1)} />
                    </React.Fragment>
                  ))}
                </div>
                </>
              }
              {complex && complexFields && (
                <>
              <Alert
                isOpen={complex && dataFiltersHaveChanged && !expanded}
                color="warning"
                className="d-flex empty-complex"
              >
                <i className="bi bi-exclamation-triangle-fill"></i>
                <div>
                    <p>Since the last time this audience was saved, one or more of the filters chosen are no longer available.</p>
                    <Button
                      size="sm"
                      color="link"
                      className="alert-link"
                      onClick={toggleMissingDataModal}
                    >
                      More details
                    </Button>
                  </div>
              </Alert>
                <Button
                  className={classNames("add complex", {"promote": complex && !expanded && empty})}
                  title="Edit Complex Filters"
                  onClick={onClickAddFilters}
                >
                  Complex Filters <i className="bi bi-caret-right-fill"></i>
                </Button>
                </>
              )}
              <Alert
                color="warning"
                isOpen={complex && !expanded && empty}
                className="d-flex empty-complex"
              >
                <i className="bi bi-info-circle-fill" />
                <div>Complex filter changes have empty filters or values.</div>
              </Alert>
            </div>
          </div>

          {/*****
           * Insights Rail
           */}
          <div
            className={classNames("insights-rail", {
              "is-adding": expanded === "add-insights",
              "is-dragging": draggingInsights,
            })}
          >
            <header>
              <h2>Insights</h2>
              <i className="spacer" />
              {access("has_explorer_edit") && (
                <div className="add-remove">
                  <Button
                    color="link"
                    className="clear-all"
                    title="Clear All Filters"
                    onClick={toggleClearAllInsightsModal}
                  >
                    <i className="bi bi-x"></i>clear all
                  </Button>
                  <Button
                    size="sm"
                    className="add"
                    title="Add Widget"
                    onClick={onClickAddInsights}
                  >
                    <i className="fa fa-plus" />
                    Insight
                  </Button>
                </div>
              )}
              <Button
                className="expand"
                title="Expand Insights View"
                onClick={onClickExpandInsights}
              >
                <i className="fa fa-expand" />
              </Button>
            </header>

            <div className="content">
              <DropZone onDrop={onInsightDrop.bind(this, 0)} />
              <div className="chart-list">
                {insight_charts.length > 0 ? insight_charts.map((chart_id, i) => (
                  <React.Fragment key={chart_id}>
                    <Chart
                      chart_id={chart_id}
                      crossfilter="false"
                      map={map}
                      viewOnly
                      allowDownload
                      loaded={(context.crossfilterStore.audienceLoaded && loaded && !isLoading).toString()}
                      draggable={access("has_explorer_edit")}
                      onRemove={onRemoveInsights}
                      onDragStart={onInsightDragStart.bind(this, i)}
                      onDragEnd={onInsightDragEnd}
                    />
                    <DropZone onDrop={onInsightDrop.bind(this, i + 1)} />
                  </React.Fragment>
                )) : null }
              </div>
            </div>
          </div>

          {/*****
           * Map/Middle Rail
           */}
          <div className="middle-rail">
              <Map
                  onMount={onMountMap}
                  onUnmount={onUnmountMap}
                  savekey="explorer:map"
                  className={classNames({
                    "is-loading": isLoadingMapCrossfilterData,
                  })}
                  mapstate={{
                    center: mapCenter,
                    zoom: mapZoom,
                  }}
                  controls={mapControls}
                >
                  {isLoadingMapCrossfilterData && <ProgressLoader />}
              </Map>
            <div
              className={classNames(
                "widget-picker",
                "add-filters",
                { "is-expanded": expanded === "add-filters" },
                { complex: complex }
              )}
            >
              {expanded === "add-filters" && !complex && (
                <React.Fragment>
                  <header>
                    <h2>Add Filters</h2>
                    <InputGroup className="widget-search">
                      <Input
                        type="search"
                        placeholder="Search"
                        onChange={onChangeSearchTerm}
                        value={searchTerm}
                        disabled={expanded !== "add-filters"}
                      />
                      <InputGroupText>
                        <i className="bi bi-search"></i>
                      </InputGroupText>
                    </InputGroup>
                    <i className="spacer" />
                    <Button
                      size="sm"
                      className="define-complex"
                      onClick={toggleConvertToComplexModal}
                    >
                      Define Complex Filters
                    </Button>
                    <HelpTip
                      id="complex-filters"
                    />
                    <button
                      className="close"
                      onClick={onClickCloseWidgetPicker}
                    >
                      <i className="fa fa-xmark" />
                    </button>
                  </header>

                  {taxonomyLoaded && (
                    <ChartFinder
                      onAddToFilters={onClickAddFilter}
                      onAddToInsights={onClickAddInsight}
                      searchTerm={searchTerm}
                      isComplex={complex}
                      hasUpdated={handleChartsHaveUpdates}
                    />
                  )}

                </React.Fragment>
              )}
              {expanded === "add-filters" && complex && complexFields && (
                <React.Fragment>
                  <header>
                    <h2>Define Complex Filters</h2>
                    <HelpTip
                      id="complex-filters"
                    />
                    <i className="spacer" />
                    <button
                      className="close"
                      onClick={onClickCloseWidgetPicker}
                    >
                      <i className="fa fa-xmark" />
                    </button>
                  </header>
                  <div className="complex-builder">
                   <Alert
                      isOpen={complex && dataFiltersHaveChanged}
                      color="warning"
                      className="d-flex"
                    >
                      <i className="bi bi-exclamation-triangle-fill"></i>
                      <div>
                        <p>Since the last time this audience was saved, one or more of the filters chosen are no longer available.</p>
                        <Button
                          size="sm"
                          color="link"
                          className="alert-link"
                          onClick={toggleMissingDataModal}
                        >
                          More details
                        </Button>
                      </div>
                    </Alert>
                    <div className="complex-msg">
                          <Alert
                            isOpen={complex && empty}
                            color="warning"
                            className="d-flex"
                          >
                            <i className="bi bi-info-circle-fill"></i>
                            <div>
                              All complex filters need to have complete fields and
                              values.
                            </div>
                          </Alert>
                        </div>
                    <ComplexFilterBuilder
                      modified={complexModified}
                      context={context}
                      initialQuery={
                        complex && complexQuery && complexQuery.tree
                          ? complexQuery.tree
                          : {}
                      }
                      updateQuery={changeComplexQuery}
                      fields={complexFields}
                      readonly={!access("has_explorer_edit")}
                    />
                    <div className="d-flex justify-content-between complex button-row">
                      {access("has_explorer_edit") && (
                        <button
                          className="actions-btn"
                          onClick={toggleRevertToSimpleModal}
                        >
                          <i className="bi bi-backspace"></i> Revert to Simple
                          Filters
                        </button>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>

            <div
              className={classNames("widget-picker", "add-insights", {
                "is-expanded": expanded === "add-insights",
              })}
            >
              {expanded === "add-insights" && (
                <React.Fragment>
                  <header>
                    <h2>Add Insights</h2>
                    <InputGroup className="widget-search">
                      <Input
                        type="search"
                        placeholder="Search"
                        onChange={onChangeSearchTerm}
                        value={searchTerm}
                        disabled={expanded !== "add-insights"}
                      />
                      <InputGroupText>
                        <i className="bi bi-search"></i>
                      </InputGroupText>
                    </InputGroup>
                    <i className="spacer" />
                    <button
                      className="close"
                      onClick={onClickCloseWidgetPicker}
                    >
                      <i className="fa fa-xmark" />
                    </button>
                  </header>

                  {taxonomyLoaded && (
                    <ChartFinder
                      onAddToFilters={onClickAddFilter}
                      onAddToInsights={onClickAddInsight}
                      searchTerm={searchTerm}
                      isComplex={complex}
                      hasUpdated={handleChartsHaveUpdates}
                    />
                  )}

                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        <Modal centered backdrop isOpen={showNeedLicense}>
          <ModalHeader>No License Fee Found</ModalHeader>
          <ModalBody>A License Fee is needed to place orders.</ModalBody>
          <ModalFooter>
            <Button onClick={() => setShowNeedLicense(false)}>Close</Button>
          </ModalFooter>
        </Modal>
        <HasLicenseFee hasLicense={hasLicense} />
        <AudienceUnsavedModal
          isShowing={showUnsavedExplorerModal}
          hide={handleReturn}
          onClickContinueHandler={handleProceed}
          className="ErrorModal__Content"
          overlayClassName="ErrorModal__Overlay"
          ariaHideApp={false}
        ></AudienceUnsavedModal>
      </div>
    );
  };
  return output();
};

// export default withRouter(React.memo(Explorer));
export default withRouter(Explorer);
